// src/pages/admin/AdminDashboard.js

import React from 'react';
import { Link } from 'react-router-dom';
import UserInfo from '../../components/UserInfo';
import Card from '../../components/Card';
import './AdminDashboard.css';

function AdminDashboard() {
    const adminLinks = [
        { path: '/admin/testimonies', label: '見證分享', description: '管理見證分享內容。' },
        { path: '/admin/sermons', label: '講台信息', description: '管理講台信息。' },
        { path: '/admin/news', label: '教會消息', description: '管理教會消息。' },
        { path: '/admin/redirects', label: '導向網址', description: '管理導向網址。' },
        { path: '/admin/pastor_messages', label: '牧者的話', description: '管理牧者的話。' },
        { path: '/admin/page_content_2', label: '網頁內容', description: '管理網頁內容。' },
        { path: '/admin/fellowship_schedules', label: '聚會時間', description: '管理聚會時間表。' },
        { path: '/admin/devotion_sharings', label: '靈修分享', description: '管理靈修分享內容。' },
        { path: '/admin/bible_study_materials', label: '查經資料', description: '管理查經資料。' },
        { path: '/admin/articles', label: '標竿刊物', description: '管理標竿刊物內容。' },
    ];

    return (
        <div className="page-content">
            <h2><Link to="/admin">管理主頁</Link></h2>
            <UserInfo />
            <div className="admin-cards">
                {adminLinks.map((link) => (
                    <Card key={link.path} path={link.path} label={link.label} description={link.description} />
                ))}
            </div>
        </div>
    );
}

export default AdminDashboard;
